import { Download } from "lucide-react";
import { useState } from "react";
import { exportFile, type ExportFormat, type SubtitleTrack } from "@/lib/export.ts";
import { languageName, type Language } from "@/lib/languages.ts";
import type { Segment } from "@/lib/protocol.ts";

export function ExportPanel({ segments, languages, meta }: { segments: Segment[]; languages: Language[]; meta: Record<string, unknown> }) {
  const [track, setTrack] = useState<SubtitleTrack>("target");
  const disabled = segments.length === 0;

  const save = (format: ExportFormat) => {
    const { body, mime, extension } = exportFile(format, segments, {
      name: (code) => languageName(languages, code),
      track,
      meta: { app: "Interligne", exportedAt: new Date().toISOString(), ...meta },
    });
    const blob = new Blob([body], { type: `${mime};charset=utf-8` });
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = `interligne-${new Date().toISOString().slice(0, 16).replace(/[:T]/g, "-")}.${extension}`;
    a.click();
    window.setTimeout(() => URL.revokeObjectURL(href), 1000);
  };

  return (
    <section className="card p-4" aria-labelledby="export-title">
      <h2 id="export-title" className="flex items-center gap-2 text-sm font-medium">
        <Download size={16} className="text-accent" /> Export
      </h2>
      <div className="mt-3 grid grid-cols-4 gap-2">
        {(["txt", "srt", "vtt", "json"] as const).map((f) => (
          <button key={f} type="button" className="btn min-h-9 px-0 uppercase" disabled={disabled} onClick={() => save(f)}>
            {f}
          </button>
        ))}
      </div>
      <label className="mt-3 flex items-center justify-between gap-2 text-xs text-muted">
        Subtitle text
        <select className="field min-h-9 text-sm text-fg" value={track} onChange={(e) => setTrack(e.target.value as SubtitleTrack)}>
          <option value="target">Translation</option>
          <option value="source">Original</option>
          <option value="both">Both</option>
        </select>
      </label>
    </section>
  );
}
